import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation actionImportLegacyPatients($input: ImportLegacyPatientsInput!) {
    actionImportLegacyPatients(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      patients {
        id
        firstName
        lastName
        legacyId
      }
      patientResults
      warnings
    }
  }
  ${ErrorMessageInfo}
`;
